import { render, staticRenderFns } from "./MapColumnsModal.vue?vue&type=template&id=02651e93"
import script from "./MapColumnsModal.vue?vue&type=script&lang=js"
export * from "./MapColumnsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports